import styled from "styled-components";

export const Container = styled.div`
  height: 32px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-right: 1px solid ${({ theme }) => theme.pallette.silver.light};
  margin-right: 20px;

  @media (max-width: 1100px) {
    justify-content: center;
    padding-right: 10px;
    margin-right: 10px;
  }
`;

export const StyledLink = styled.a`
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  color: ${({ theme }) => theme.pallette.white.primary};
  text-decoration: underline;
  line-height: 18px;

  &:hover {
    text-decoration: none;
  }
`;
